import { Line } from "features/LinearAlgebra/linearAlgebraModel";
import { areCloseScalar, distance } from "features/LinearAlgebra/vectorUtils";

export function checkIfDistMeasureShouldBeHidden(line: Line) {
  return areCloseScalar(distance(line[0], line[1]), 0);
}
